import styled from 'styled-components';

export const StyledBackToTop = styled.div<{
  isVisible: boolean;
  invert?: boolean;
  position: 'fixed' | 'absolute';
}>`
  position: ${(props) => props.position};
  transform: ${(props) => props.invert && 'rotate(180deg)'};
  transition-duration: 0.4s;
  transition-property: visibility, opacity;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
  right: 1rem;
  bottom: 1rem;
  z-index: 1;
  width: 2.5rem;
  height: 2.5rem;
  color: ${(props) => props.theme.colors.primary.main};
  cursor: pointer;

  ${({ theme }) => theme.mediaQueries.min.md} {
    right: 2.5rem;
    bottom: 2.5rem;
    width: 3.75rem;
    height: 3.75rem;

    &:hover {
      opacity: 0.7;
    }
  }
`;
